// import Basic from './Basic';

export default {
  // component: Basic,
  permissions:['BasicInformationMenu/'] , // ['PersonnelMenu', 'ChartMenu', 'PermissionsDefinitionMenu', 'AssignPermissionsMenu'],
  priority: 900,
  name: app.translate('routes.home.Basic Information'),
  icon: 'information-outline',
  drawer: true,
};
